import _ from 'lodash';
import { MoveableFrozenLineProps } from '../components/grid/freeze/useFrozenLines';
import { SheetDefaults } from '../constants/sheetDefaults';
import { convertPositionToArea } from '../utils/area/area';
import { createVisibleAreas } from './selectionHelper';
import { getSheetCellsLeft } from './sheetRTLHelper';
import { getViewportStartEnd } from '../utils/views/virtualViewport';

export const getHorizontalFrozenLinePos = (
  linePos: number,
  expectedIndex: number,
  props: MoveableFrozenLineProps
) => {
  const freezeBarHandleSize = SheetDefaults.freezeBarHandleSize * props.zoom;
  // const viewport = props.viewport;
  let top = props.colFilterHeight + props.colHeaderHeight; // props.groupBarHeight +

  const newRi = expectedIndex;
  // const left = getSheetCellsLeft(
  //   props.width,
  //   props.rowHeaderWidth,
  //   props.isRtl
  // );

  let lineTop = top;

  const minTop = top - freezeBarHandleSize - props.colFilterHeight;

  if (newRi === -1) {
    lineTop = minTop;
  } else {
    const freezeRange = getViewportStartEnd(props.rowViewport.frozenIndexes);
    const { start: rs, end: re } = getViewportStartEnd(
      props.rowViewport.nonFrozenIndexes
    );
    const { placement, size } = createVisibleAreas(
      props.rowViewport,
      props.defaultRowHeight,
      convertPositionToArea({ ri: newRi, ci: 0 }),
      { start: { ri: rs, ci: 0 }, end: { ri: re, ci: 0 } },
      props.freezedRows,
      // props.freezedRowsSum,
      top,
      'ri',
      freezeRange.start,
      freezeRange.end,
      rs,
      re,
      false,
      props.zoom
    );

    lineTop = placement + size;
  }

  const expectedFreezePlacement = {
    top: lineTop,
    left: 0,
    width: props.width,
    height: freezeBarHandleSize,
  };

  return {
    expectedFreezePlacement,
    moveableLine: {
      ...expectedFreezePlacement,
      top: Math.min(Math.max(linePos, minTop), props.y + props.height),
    },
  };
};

export const getVerticalFrozenLinePos = (
  linePos: number,
  expectedIndex: number,
  props: MoveableFrozenLineProps
) => {
  const { zoom, width, rowHeaderWidth, isRtl, colViewport } = props;

  const freezeBarHandleSize = SheetDefaults.freezeBarHandleSize * zoom;

  const newCi = expectedIndex;
  const left = getSheetCellsLeft(width, rowHeaderWidth, isRtl);

  const top = props.y; // + props.groupBarHeight

  let lineLeft = left;

  if (newCi === -1) {
    lineLeft = isRtl ? left : left - freezeBarHandleSize;
  } else {
    const freezeRange = getViewportStartEnd(colViewport.frozenIndexes);
    const { start: cs, end: ce } = getViewportStartEnd(
      colViewport.nonFrozenIndexes
    );
    const { placement, size } = createVisibleAreas(
      colViewport,
      props.defaultColWidth,
      convertPositionToArea({ ri: 0, ci: newCi }),
      { start: { ri: 0, ci: cs }, end: { ri: 0, ci: ce } },
      props.freezedCols,
      // props.freezedColsSum,
      left,
      'ci',
      freezeRange.start,
      freezeRange.end,
      cs,
      ce,
      isRtl,
      zoom
    );

    lineLeft = props.isRtl ? placement - freezeBarHandleSize : placement + size;
  }
  const expectedFreezePlacement = {
    top: top,
    left: lineLeft,
    width: freezeBarHandleSize,
    height: props.height,
  };

  const leftMin = props.x + rowHeaderWidth - freezeBarHandleSize;

  const leftMax = props.x + width - rowHeaderWidth;

  return {
    expectedFreezePlacement,
    moveableLine: {
      ...expectedFreezePlacement,
      left: isRtl ? Math.min(linePos, leftMax) : Math.max(linePos, leftMin),
    },
  };
};
